type ReviewDestinationUrlInput = {
  url?: string
  brand?: string | null
  publisher_id?: string
}

type ReviewDestinationUrlOutput = {
  url: string
  brand?: string
  publisher_id?: string
}

export function formatReviewDestinationUrls(
  urls?: ReviewDestinationUrlInput[]
): ReviewDestinationUrlOutput[] {
  if (!urls?.length) return []

  return urls
    .map(({ url, brand, publisher_id }) => {
      const trimmedUrl = url?.trim()
      if (!trimmedUrl) return null

      const destination: ReviewDestinationUrlOutput = { url: trimmedUrl }

      if (brand) {
        destination.brand = brand
      }

      if (publisher_id) {
        destination.publisher_id = publisher_id
      }

      return destination
    })
    .filter((item): item is ReviewDestinationUrlOutput => item !== null)
}

export function previewRejectedDestinationUrls({
  current,
  suggested
}: {
  current?: ReviewDestinationUrlInput[]
  suggested?: ReviewDestinationUrlInput[]
}): ReviewDestinationUrlOutput[] {
  const filledCurrent = formatReviewDestinationUrls(current)

  return filledCurrent.length
    ? filledCurrent
    : formatReviewDestinationUrls(suggested)
}
